export const trackGoogleConversion = (sendToValue, value = 0, currency = 'USD') => {
    console.log(window.gtag)
    if (window.gtag) {
        window.gtag('event', 'conversion', {
            'send_to': sendToValue,
            'value': value,
            'currency': currency
        });
    } else {
        console.warn("Google Ads gtag.js is not initialized yet.");
    }
};
